// 🔬 진단 데이터 수집기 — 모든 다른 import보다 먼저 초기화하여
// console, fetch, window.onerror 오버라이드가 최초 에러도 캡처할 수 있도록 합니다.
import { diagnosticCollector } from './services/DiagnosticCollector';
diagnosticCollector.init();

import * as Sentry from "@sentry/react";
import { Capacitor } from '@capacitor/core';
import { i18n } from "@lingui/core";
import { I18nProvider } from '@lingui/react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initateLingui } from './locales/InitTranslation';
import { PushService } from './services/Utils/PushService';

import package_json from './../package.json';

// Sentry 초기화 - 오류 추적 및 성능 모니터링
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: `nextpod@${package_json.version}`,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // 성능 모니터링 샘플 비율 (개발: 100%, 프로덕션에서는 0.1~0.2 권장)
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.2,
  // 세션 리플레이 (프로덕션에서만 활성화)
  replaysSessionSampleRate: import.meta.env.DEV ? 0 : 0.1,
  replaysOnErrorSampleRate: 1.0,
  // 환경 설정
  environment: import.meta.env.DEV ? 'development' : 'production',
  // 불필요한 노이즈성 오류 무시 (브라우저 내부 문제만)
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    "Can't find variable: EmptyRanges",
    "EmptyRanges is not defined",
    // 배포 간 에셋 경로 불일치 (SPA rewrite가 index.html 반환)
    'Failed to fetch dynamically imported module',
    'is not a valid JavaScript MIME type',
    'Importing a module script failed',
    // 사용자 환경 에러 (코드 문제 아님)
    'Failed to get document because the client is offline',
    'Connection to Indexed Database server lost',
  ],
});

const container = document.getElementById('root');
const root = createRoot(container!);

initateLingui().then(() => {
  root.render(
    // <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
    //  </React.StrictMode>
  );
});

if (Capacitor.getPlatform() === 'ios') {
  document.body.className = 'ios-mode';
}

// PushService.init()은 로그인 완료 후 FireClientAuth에서 호출됨

// 배포 후 에셋 경로 불일치 자동 복구
// 새 배포 시 이전 에셋이 삭제되면, 캐시된 HTML이 사라진 에셋을 요청하여 실패할 수 있음.
// 이 경우 페이지를 자동 리로드하여 새 HTML(올바른 에셋 경로)을 받아옴.
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (
    reason instanceof TypeError &&
    (reason.message?.includes('dynamically imported module') ||
     reason.message?.includes('MIME type') ||
     reason.message?.includes('Importing a module script failed') ||
     reason.message?.includes('Loading chunk'))
  ) {
    // 무한 리로드 방지: 10초 쿨다운
    const RELOAD_KEY = 'chunk-load-reload';
    const lastReload = sessionStorage.getItem(RELOAD_KEY);
    const now = Date.now();

    if (!lastReload || now - parseInt(lastReload) > 10000) {
      sessionStorage.setItem(RELOAD_KEY, now.toString());
      window.location.reload();
    }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
